import React from 'react';
import { SuggestionUI } from './ui';

export const SuggestionScreen: React.FC = (): JSX.Element => {
  return <SuggestionUI />;
};
